(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionString', {
		bindings: {
			condition: '<',
			operators: '<',
		},
		controller: MxSearchQueryConditionStringCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/by-type/mx-search-query-condition-string.html',
	});

	MxSearchQueryConditionStringCtrl.$inject = ['$scope', 'mx.shell.Config', 'mx.internationalization'];

	function MxSearchQueryConditionStringCtrl($scope, configService, i18n) {
		const vm = this;
		vm.maxWordsPerCondition = configService.get('maxWordsPerCondition');
		vm.maxWordsValidationMessage = i18n.getFormatted('solutionBuilderAgent.components.mx-search-query-condition.tooManyWords', vm.maxWordsPerCondition);

		vm.$onInit = function () {
			if (vm.condition) {
				if (!Array.isArray(vm.condition.value) || !vm.condition.value.length) {
					vm.condition.value = [''];
				} else if (vm.condition.value.length > 1) {
					vm.condition.value = [vm.condition.value[0]];
				}
			}
		};

		const w = $scope.$watchGroup(['vm.condition.value[0]', 'vm.condition.operator'], updateConditionValidity);
		$scope.$on('$destroy', () => w());
		return vm;

		function updateConditionValidity() {
			const searchText = (vm.condition.value && vm.condition.value[0]) || '';
			vm.condition.__valid = false;
			vm.customValidation = null;

			switch (vm.condition.operator) {
				case vm.operators.IsNotSet.value:
				case vm.operators.IsSet.value:
					vm.condition.__valid = true;
					break;

				case vm.operators.ContainsAllWords.value:
				case vm.operators.ContainsAnyWord.value:
				case vm.operators.DoesNotContainAnyWord.value:
				case vm.operators.DoesNotContainAllWords.value:
					vm.condition.__valid = searchText && searchText.split(/[,|.|;| ]/).length <= vm.maxWordsPerCondition;
					if (searchText && !vm.condition.__valid) {
						vm.customValidation = {
							IsValid: false,
							ErrorMessage: vm.maxWordsValidationMessage,
						};
					}

					break;
				default:
					vm.condition.__valid = searchText.length > 0;
			}
		}
	}
})();
